import React, {useContext} from 'react';

import ApplicationButton from "../ApplicationButton";

import {APPLICATIONS as Apps} from "utils/Applications";
import {OMSRoutes} from "utils/OMSRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";

function OmsItem(props) {
    const {selectedApplication} = useContext(SidebarContext);

    return (
        <ApplicationButton
            to={OMSRoutes.PICKING}
            application={Apps.OMS}
            selected={selectedApplication === Apps.OMS}
        />
    );
}

export default OmsItem;
